var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta?.auth)?_c('div',{staticClass:"debug-button-wrapper",on:{"click":function($event){return _vm.open()}}},[_c('font-awesome-icon',{attrs:{"icon":"bug"}}),_c('p',[_vm._v("Fout gevonden?")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }